import { WhatsApp } from "@mui/icons-material";
import { Headset } from "lucide-react";
import React from "react";
import { FaTimes } from "react-icons/fa";
import ModaRedirect from "../simulador-economia/_components/ModaRedirect";

const mapperCanaisAtendimento = [
  { name: "WhastApp", link: "https://wa.me/5511947817622", icon: <WhatsApp /> },
];

export function AtendimentoContent({
  canais = mapperCanaisAtendimento,
  onClose,
  isOpen,
}) {
  return (
    <ModaRedirect isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col h-[100vh] items-start justify-end md:justify-center">
        <div className="relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6">
          <Headset size={40} color="#DA291C" />

          <button
            type="button"
            className="absolute top-4 right-4 text-black"
            onClick={onClose}
            aria-label="Fechar"
          >
            <FaTimes className="w-6 h-6" />
          </button>

          <p className="text-xl text-center font-medium px-4 mt-3 mb-5">
            Atendimento
          </p>

          <div className="h-px w-full bg-[#D1D5DB]" />

          <div className="mt-6 space-y-4 w-full">
            {canais.map((canal) => (
              <div key={canal.name} className="w-full">
                <div className="flex items-center gap-3">
                  <div className="text-black">{canal.icon}</div>

                  <div className="flex items-center gap-2 text-sm text-black">
                    <span className="font-medium">{canal.name}</span>
                    <span className="text-black/40">:</span>
                    <a
                      href={canal.link}
                      target="_blank"
                      rel="noreferrer"
                      className="underline underline-offset-4 hover:text-black"
                    >
                      Clique aqui
                    </a>
                  </div>
                </div>

                <div className="mt-4 h-px w-full bg-[#D1D5DB]" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </ModaRedirect>
  );
}
